import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectChannelId, setChannelInfo } from "../../features/appSlice";
import "./SidebarChannel.css";

function SidebarChannel({ id, channel }) {
  const dispatch = useDispatch();
  const currentChannelId = useSelector(selectChannelId);
  const handleChannelClick = () => {
    dispatch(
      setChannelInfo({
        channelId: id,
        channelName: channel,
      })
    );
  };

  return (
    <div
      className={`sidebarChannel ${
        currentChannelId === id && "sidebarChannel--active"
      }`}
      onClick={handleChannelClick}
    >
      <h4>
        <span className="sidebarChannel__hash">#</span>
        {channel}
      </h4>
    </div>
  );
}

export default SidebarChannel;
